import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import './Dashboard.css'


const ForgotPassword = () => {

	const [email, setEmail] = useState(""); //Simple one String state no object as no multiple field
	const [errors, setErrors] = useState({});
	const [message, setMessage] = useState("");
	const [isSubmitting, setIsSubmitting] = useState(false);
	const navigate = useNavigate();

	const handleChange = (e) => {
		const { value } = e.target;
		setEmail(value);
		if (errors.email) setErrors({});
	};

	const validate = () => {
		if (!/\S+@\S+\.\S+/.test(email)) {
			setErrors({ email: "Invalid Email Format !" });
			return false;
		}

		setErrors({});
		return true;

	};


	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!validate()) return;
		setIsSubmitting(true)
		setMessage("");

		try {

			const res = await fetch("/api/v1/auth/password/forgot", {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ email })

			});
			if (res.ok) {
				setMessage("Password reset link sent on your email!");
				setErrors({});
				//set some delay So user can see success message
				setTimeout(() => navigate("/login"), 3000);

			}

			else if (res.status === 400) {
				setErrors({ email: "User doesn't exist with this email" });
				setMessage("");
				setIsSubmitting(false)

			} else {
				alert("Something went wrong or Server Down. Try again.");
			}

		} catch (error) {
			console.error('Actual JS Error', error);
			alert("Network error")

		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div className="registration-container">
			<form onSubmit={handleSubmit} className="registration-form">
				<div className="form-group">
					<input name='email' type='email' value={email} onBlur={validate} onChange={handleChange} placeholder='Registered email' />

					{errors.email && <span className="error-text">{errors.email} </span>}
					{message && <span className="success-text"> {message}</span>}

				</div>

				<button type='submit' disabled={isSubmitting} className="submit-btn">
					{isSubmitting ? <div className="loader"> </div> : "Reset password"}
				</button>

			</form>

		</div>


	);
};

export default ForgotPassword;